import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Main from './Main'
import { LanguageProvider } from './context/LanguageContext'

const App = () => {
  return (
    <div>
      <BrowserRouter>
      <LanguageProvider>

      <Routes>
        <Route path='/' element={<Main/>}/>
        <Route path='*' element={<Main/>}/>
      </Routes>
      </LanguageProvider>
      </BrowserRouter>
    </div>
  )
}

export default App
